/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable react/jsx-key */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react'
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

interface PropsType {
    dataset: any;
    labels: any;
}

function BarGraphComponent({ dataset, labels }: PropsType): JSX.Element {
    const [barProps, setBarProps] = useState<any>(
        labels.reduce(
          (a:any, { key }: any) => {
            a[key] = false;
            return a;
          },
          { hover: null }
        )
      );

      const selectBar = (e: any): void => {
        setBarProps({
          ...barProps,
          [e.dataKey]: !barProps[e.dataKey],
          hover: null
        });
      };

    return (
        <ResponsiveContainer width="100%" height="80%">
            <BarChart 
              // width={730} height={250} 
              data={dataset}
              margin={{
                top: 5,
                right: 30,
                left: 20,
                bottom: 5,
              }}
            >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="date" stroke="#3A3A3A" interval={3} tickFormatter={(value, index) => (index === 0 ? '' : value)}/>
                <YAxis stroke="#3A3A3A"  />
                <Tooltip cursor={{fill: 'rgba(250, 250, 250, 0.6)'}}/>
                <Legend onClick={selectBar} iconType='circle'/>
                {
                    labels.map((label: any) => (
                        <Bar type="monotone" dataKey={label.key} name={label.label} fill={label.color} barSize={4} hide={barProps[label.key] === true}/>
                    ))
                }

            </BarChart>
        </ResponsiveContainer>
    )
}

export default BarGraphComponent